// The Leads page and a lead's page (pages/Leads): the business's sales and call-centre work on
// people who asked about a course, from the first call to a student account.
const leads = {
  en: {
    title: 'Leads',
    openLead: 'Open the lead',
    subtitle: 'Call the people who asked about a course and turn them into students',
    add: 'Add lead',
    kpi: {
      dueNow: 'Calls due',
      dueNowHint: 'overdue included',
      dueToday: 'Today',
      dueTodayHint: 'calls planned for today',
      newLeads: 'New',
      newLeadsHint: 'nobody has called yet',
      conversion: 'Conversion',
      conversionHint: '{count} became students',
    },
    status: {
      NEW: 'New',
      CONTACTED: 'Contacted',
      INTERESTED: 'Interested',
      PAYMENT_PENDING: 'Payment pending',
      CONVERTED: 'Became a student',
      LOST: 'Lost',
    },
    outcome: {
      REACHED: 'Reached',
      NO_ANSWER: 'No answer',
      BUSY: 'Busy',
      CALL_BACK: 'Asked to call back',
      WRONG_NUMBER: 'Wrong number',
      NOT_INTERESTED: 'Not interested',
    },
    source: {
      landing: 'Website',
      crmRegister: 'CRM request',
      manual: 'Added by hand',
    },
    filters: {
      status: 'Status',
      statusAll: 'All',
      statusOpen: 'In progress',
      owner: 'Owner',
      ownerAll: 'Everyone',
      ownerMe: 'Mine',
      ownerNone: 'No owner',
      due: 'Call',
      dueAll: 'Any time',
      dueNow: 'Due now',
      dueToday: 'Today',
      dueUpcoming: 'Later',
      dueUnscheduled: 'Not planned',
      sort: 'Order',
      sortRecent: 'Newest first',
      sortNextCall: 'By call time',
      clear: 'Clear filters',
    },
    searchPlaceholder: 'Name or phone...',
    col: {
      lead: 'Lead',
      status: 'Status',
      owner: 'Owner',
      nextCall: 'Next call',
      lastContact: 'Last call',
      source: 'Source',
    },
    overdue: 'overdue',
    notPlanned: 'Not planned',
    never: 'Not yet',
    noOwner: 'No owner',
    emptyTitle: 'No leads yet',
    emptyDesc: 'Website requests and the leads you add by hand show up here.',
    noMatchTitle: 'No lead matches',
    noMatchDesc: 'Try another name or number, or clear the filters.',
    loadError: 'Could not load the leads',
    form: {
      title: 'New lead',
      firstName: 'First name',
      lastName: 'Last name',
      phone: 'Phone',
      phonePlaceholder: '+998 90 123 45 67',
      course: 'Course of interest',
      courseNone: 'Not chosen',
      owner: 'Owner',
      ownerMe: 'Me',
      notes: 'Note',
      notesPlaceholder: 'Where they heard about us, what they asked...',
      firstCall: 'First call',
      date: 'Date',
      time: 'Time',
      save: 'Add lead',
      cancel: 'Cancel',
      saved: 'Lead added',
      saveError: 'Could not save the lead',
      duplicate: 'A lead with this number already exists',
      phoneInvalid: 'Enter the full phone number',
      nameRequired: 'Enter a first name',
    },
    detail: {
      call: 'Call',
      status: 'Status',
      owner: 'Owner',
      course: 'Course',
      source: 'Source',
      created: 'Added',
      lastContact: 'Last call',
      nextCall: 'Next call',
      contactTime: 'Convenient time',
      survey: 'Request answers',
      learningPurpose: 'Goal',
      courseExpectations: 'Expectations',
      previousExperience: 'Experience',
      difficulties: 'Difficulties',
      notes: 'Note',
      convert: 'Turn into a student',
      openStudent: 'Student page',
      convertTitle: 'Turn {name} into a student?',
      convertDesc: 'A student account is opened with this phone (or the existing one is linked). They sign in with an SMS code.',
      convertConfirm: 'Turn into a student',
      convertDone: 'The student account is ready',
      convertLinked: 'Linked to the existing student account',
      convertError: 'Could not turn the lead into a student',
      notFoundTitle: 'Lead not found',
      notFoundDesc: 'It was deleted or belongs to another business.',
      loadError: 'Could not load the lead',
      saved: 'Saved',
      saveError: 'Could not save the change',
      reschedule: 'Change the call time',
      cancelCall: 'Cancel the planned call',
      planCall: 'Plan a call',
    },
    call: {
      title: 'Log a call',
      outcome: 'How did it go?',
      note: 'Note',
      notePlaceholder: 'What did you talk about?',
      nextCall: 'Next call',
      noNextCall: 'No further call',
      status: 'Lead status',
      keepStatus: 'Leave as it is',
      save: 'Save the call',
      saved: 'Call saved',
      saveError: 'Could not save the call',
      outcomeRequired: 'Choose how the call went',
      tomorrow: 'Tomorrow',
      inThreeDays: 'In 3 days',
      nextWeek: 'In a week',
    },
    note: {
      label: 'Add a note',
      placeholder: 'Write a note...',
      add: 'Add',
      added: 'Note added',
      error: 'Could not save the note',
    },
    timeline: {
      title: 'History',
      empty: 'No calls or notes yet',
      call: 'Call',
      note: 'Note',
      statusChange: 'Status: {from} → {to}',
      assigned: '{name} is the owner now',
      unassigned: 'The owner was removed',
      someone: 'Staff member',
    },
  },
  ru: {
    title: 'Лиды',
    openLead: 'Открыть лида',
    subtitle: 'Звоните тем, кто интересовался курсом, и превращайте их в студентов',
    add: 'Добавить лид',
    kpi: {
      dueNow: 'Пора звонить',
      dueNowHint: 'вместе с просроченными',
      dueToday: 'Сегодня',
      dueTodayHint: 'звонки на сегодня',
      newLeads: 'Новые',
      newLeadsHint: 'ещё никто не звонил',
      conversion: 'Конверсия',
      conversionHint: 'стали студентами: {count}',
    },
    status: {
      NEW: 'Новый',
      CONTACTED: 'Связались',
      INTERESTED: 'Заинтересован',
      PAYMENT_PENDING: 'Ждёт оплаты',
      CONVERTED: 'Стал студентом',
      LOST: 'Потерян',
    },
    outcome: {
      REACHED: 'Дозвонились',
      NO_ANSWER: 'Не ответил',
      BUSY: 'Занято',
      CALL_BACK: 'Просил перезвонить',
      WRONG_NUMBER: 'Неверный номер',
      NOT_INTERESTED: 'Не интересно',
    },
    source: {
      landing: 'Сайт',
      crmRegister: 'Заявка в CRM',
      manual: 'Добавлен вручную',
    },
    filters: {
      status: 'Статус',
      statusAll: 'Все',
      statusOpen: 'В работе',
      owner: 'Ответственный',
      ownerAll: 'Все',
      ownerMe: 'Мои',
      ownerNone: 'Без ответственного',
      due: 'Звонок',
      dueAll: 'Любое время',
      dueNow: 'Пора звонить',
      dueToday: 'Сегодня',
      dueUpcoming: 'Позже',
      dueUnscheduled: 'Не запланирован',
      sort: 'Порядок',
      sortRecent: 'Сначала новые',
      sortNextCall: 'По времени звонка',
      clear: 'Сбросить фильтры',
    },
    searchPlaceholder: 'Имя или телефон...',
    col: {
      lead: 'Лид',
      status: 'Статус',
      owner: 'Ответственный',
      nextCall: 'Следующий звонок',
      lastContact: 'Последний звонок',
      source: 'Источник',
    },
    overdue: 'просрочен',
    notPlanned: 'Не запланирован',
    never: 'Ещё нет',
    noOwner: 'Нет ответственного',
    emptyTitle: 'Лидов пока нет',
    emptyDesc: 'Здесь появятся заявки с сайта и лиды, добавленные вручную.',
    noMatchTitle: 'Лиды не найдены',
    noMatchDesc: 'Попробуйте другое имя или номер либо сбросьте фильтры.',
    loadError: 'Не удалось загрузить лиды',
    form: {
      title: 'Новый лид',
      firstName: 'Имя',
      lastName: 'Фамилия',
      phone: 'Телефон',
      phonePlaceholder: '+998 90 123 45 67',
      course: 'Интересующий курс',
      courseNone: 'Не выбран',
      owner: 'Ответственный',
      ownerMe: 'Я',
      notes: 'Заметка',
      notesPlaceholder: 'Откуда узнал, что спрашивал...',
      firstCall: 'Первый звонок',
      date: 'Дата',
      time: 'Время',
      save: 'Добавить лид',
      cancel: 'Отмена',
      saved: 'Лид добавлен',
      saveError: 'Не удалось сохранить лид',
      duplicate: 'Лид с этим номером уже есть',
      phoneInvalid: 'Введите номер полностью',
      nameRequired: 'Введите имя',
    },
    detail: {
      call: 'Позвонить',
      status: 'Статус',
      owner: 'Ответственный',
      course: 'Курс',
      source: 'Источник',
      created: 'Добавлен',
      lastContact: 'Последний звонок',
      nextCall: 'Следующий звонок',
      contactTime: 'Удобное время',
      survey: 'Ответы из заявки',
      learningPurpose: 'Цель',
      courseExpectations: 'Ожидания',
      previousExperience: 'Опыт',
      difficulties: 'Трудности',
      notes: 'Заметка',
      convert: 'Сделать студентом',
      openStudent: 'Страница студента',
      convertTitle: 'Сделать {name} студентом?',
      convertDesc: 'По этому телефону откроется аккаунт студента (или привяжется существующий). Вход — по SMS-коду.',
      convertConfirm: 'Сделать студентом',
      convertDone: 'Аккаунт студента готов',
      convertLinked: 'Привязан к существующему аккаунту студента',
      convertError: 'Не удалось сделать лида студентом',
      notFoundTitle: 'Лид не найден',
      notFoundDesc: 'Он удалён или относится к другому бизнесу.',
      loadError: 'Не удалось загрузить лида',
      saved: 'Сохранено',
      saveError: 'Не удалось сохранить изменение',
      reschedule: 'Перенести звонок',
      cancelCall: 'Отменить звонок',
      planCall: 'Запланировать звонок',
    },
    call: {
      title: 'Записать звонок',
      outcome: 'Чем закончился звонок?',
      note: 'Заметка',
      notePlaceholder: 'О чём говорили?',
      nextCall: 'Следующий звонок',
      noNextCall: 'Больше не звонить',
      status: 'Статус лида',
      keepStatus: 'Не менять',
      save: 'Сохранить звонок',
      saved: 'Звонок сохранён',
      saveError: 'Не удалось сохранить звонок',
      outcomeRequired: 'Выберите итог звонка',
      tomorrow: 'Завтра',
      inThreeDays: 'Через 3 дня',
      nextWeek: 'Через неделю',
    },
    note: {
      label: 'Добавить заметку',
      placeholder: 'Напишите заметку...',
      add: 'Добавить',
      added: 'Заметка добавлена',
      error: 'Не удалось сохранить заметку',
    },
    timeline: {
      title: 'История',
      empty: 'Звонков и заметок пока нет',
      call: 'Звонок',
      note: 'Заметка',
      statusChange: 'Статус: {from} → {to}',
      assigned: 'Ответственный: {name}',
      unassigned: 'Ответственный снят',
      someone: 'Сотрудник',
    },
  },
  uz: {
    title: 'Lidlar',
    openLead: 'Lidni ochish',
    subtitle: "Kursga qiziqqanlarga qo'ng'iroq qiling va ularni o'quvchiga aylantiring",
    add: "Lid qo'shish",
    kpi: {
      dueNow: "Qo'ng'iroq vaqti keldi",
      dueNowHint: 'kechikkanlari bilan',
      dueToday: 'Bugun',
      dueTodayHint: "bugungi qo'ng'iroqlar",
      newLeads: 'Yangi',
      newLeadsHint: "hali qo'ng'iroq qilinmagan",
      conversion: 'Konversiya',
      conversionHint: "{count} tasi o'quvchi bo'ldi",
    },
    status: {
      NEW: 'Yangi',
      CONTACTED: "Bog'lanildi",
      INTERESTED: 'Qiziqdi',
      PAYMENT_PENDING: "To'lov kutilmoqda",
      CONVERTED: "O'quvchi bo'ldi",
      LOST: "Yo'qotildi",
    },
    outcome: {
      REACHED: 'Gaplashildi',
      NO_ANSWER: 'Javob bermadi',
      BUSY: 'Band',
      CALL_BACK: "Qayta qo'ng'iroq so'radi",
      WRONG_NUMBER: "Noto'g'ri raqam",
      NOT_INTERESTED: 'Qiziqmaydi',
    },
    source: {
      landing: 'Sayt',
      crmRegister: "CRM so'rovi",
      manual: "Qo'lda qo'shilgan",
    },
    filters: {
      status: 'Holat',
      statusAll: 'Barchasi',
      statusOpen: 'Ishdagilar',
      owner: "Mas'ul",
      ownerAll: 'Hammasi',
      ownerMe: 'Meniki',
      ownerNone: "Mas'ulsiz",
      due: "Qo'ng'iroq",
      dueAll: 'Istalgan vaqt',
      dueNow: 'Vaqti keldi',
      dueToday: 'Bugun',
      dueUpcoming: 'Keyinroq',
      dueUnscheduled: 'Rejalashtirilmagan',
      sort: 'Tartib',
      sortRecent: 'Avval yangilari',
      sortNextCall: "Qo'ng'iroq vaqti bo'yicha",
      clear: 'Filtrlarni tozalash',
    },
    searchPlaceholder: 'Ism yoki telefon...',
    col: {
      lead: 'Lid',
      status: 'Holat',
      owner: "Mas'ul",
      nextCall: "Keyingi qo'ng'iroq",
      lastContact: "Oxirgi qo'ng'iroq",
      source: 'Manba',
    },
    overdue: 'kechikdi',
    notPlanned: 'Rejalashtirilmagan',
    never: "Hali yo'q",
    noOwner: "Mas'ul yo'q",
    emptyTitle: "Hali lidlar yo'q",
    emptyDesc: "Saytdan kelgan arizalar va qo'lda qo'shilgan lidlar shu yerda ko'rinadi.",
    noMatchTitle: 'Bunday lid topilmadi',
    noMatchDesc: "Boshqa ism yoki raqam bilan qidiring yoki filtrlarni tozalang.",
    loadError: "Lidlarni yuklab bo'lmadi",
    form: {
      title: 'Yangi lid',
      firstName: 'Ism',
      lastName: 'Familiya',
      phone: 'Telefon',
      phonePlaceholder: '+998 90 123 45 67',
      course: 'Qiziqqan kursi',
      courseNone: 'Tanlanmagan',
      owner: "Mas'ul",
      ownerMe: 'Men',
      notes: 'Izoh',
      notesPlaceholder: "Qayerdan bildi, nimani so'radi...",
      firstCall: "Birinchi qo'ng'iroq",
      date: 'Sana',
      time: 'Vaqt',
      save: "Lid qo'shish",
      cancel: 'Bekor qilish',
      saved: "Lid qo'shildi",
      saveError: "Lidni saqlab bo'lmadi",
      duplicate: 'Bu raqamli lid allaqachon bor',
      phoneInvalid: "Telefon raqamini to'liq kiriting",
      nameRequired: 'Ismni kiriting',
    },
    detail: {
      call: "Qo'ng'iroq qilish",
      status: 'Holat',
      owner: "Mas'ul",
      course: 'Kurs',
      source: 'Manba',
      created: "Qo'shilgan",
      lastContact: "Oxirgi qo'ng'iroq",
      nextCall: "Keyingi qo'ng'iroq",
      contactTime: 'Qulay vaqt',
      survey: 'Ariza javoblari',
      learningPurpose: 'Maqsadi',
      courseExpectations: 'Kutgan natijasi',
      previousExperience: 'Tajribasi',
      difficulties: 'Qiyinchiliklari',
      notes: 'Izoh',
      convert: "O'quvchiga aylantirish",
      openStudent: "O'quvchi sahifasi",
      convertTitle: "{name} o'quvchiga aylantirilsinmi?",
      convertDesc: "Shu telefon bilan o'quvchi akkaunti ochiladi (bor bo'lsa, unga bog'lanadi). U platformaga SMS kod bilan kiradi.",
      convertConfirm: 'Aylantirish',
      convertDone: "O'quvchi akkaunti tayyor",
      convertLinked: "Mavjud o'quvchi akkauntiga bog'landi",
      convertError: "O'quvchiga aylantirib bo'lmadi",
      notFoundTitle: 'Lid topilmadi',
      notFoundDesc: "U o'chirilgan yoki boshqa biznesga tegishli.",
      loadError: "Lidni yuklab bo'lmadi",
      saved: 'Saqlandi',
      saveError: "O'zgarishni saqlab bo'lmadi",
      reschedule: "Qo'ng'iroq vaqtini o'zgartirish",
      cancelCall: "Rejadagi qo'ng'iroqni bekor qilish",
      planCall: "Qo'ng'iroqni rejalashtirish",
    },
    call: {
      title: "Qo'ng'iroqni yozish",
      outcome: "Qo'ng'iroq qanday o'tdi?",
      note: 'Izoh',
      notePlaceholder: 'Nima haqida gaplashdingiz?',
      nextCall: "Keyingi qo'ng'iroq",
      noNextCall: "Boshqa qo'ng'iroq kerak emas",
      status: 'Lid holati',
      keepStatus: "O'zgarmasin",
      save: "Qo'ng'iroqni saqlash",
      saved: "Qo'ng'iroq saqlandi",
      saveError: "Qo'ng'iroqni saqlab bo'lmadi",
      outcomeRequired: "Qo'ng'iroq natijasini tanlang",
      tomorrow: 'Ertaga',
      inThreeDays: '3 kundan keyin',
      nextWeek: 'Bir haftadan keyin',
    },
    note: {
      label: 'Izoh qoldirish',
      placeholder: 'Izoh yozing...',
      add: "Qo'shish",
      added: "Izoh qo'shildi",
      error: "Izohni saqlab bo'lmadi",
    },
    timeline: {
      title: 'Tarix',
      empty: "Hali qo'ng'iroq yoki izoh yo'q",
      call: "Qo'ng'iroq",
      note: 'Izoh',
      statusChange: 'Holat: {from} → {to}',
      assigned: "{name} mas'ul qilindi",
      unassigned: "Mas'ul olib tashlandi",
      someone: 'Xodim',
    },
  },
};

export default leads;
